/**
 * Cálculos relacionados a riscos
 * Funções para calcular tolerância ao risco e formatação numérica
 */

/**
 * Calcula a tolerância ao risco baseado no HRN
 * @param hrn Valor do HRN
 * @returns "Alta", "Média" ou "Baixa"
 */
export function calcularToleranciaRisco(hrn: number): string {
  if (hrn >= 60) return 'Alta';
  if (hrn >= 3) return 'Média';
  return 'Baixa';
}

/**
 * Formata número para exibição em LaTeX (usa vírgula como separador decimal)
 * @param valor Valor numérico
 * @param decimais Número de casas decimais (padrão: 3)
 * @returns String formatada com vírgula
 */
export function formatarNumeroBR(valor: number, decimais: number = 3): string {
  // Verificar se o valor é válido
  if (valor === null || valor === undefined || isNaN(valor) || !isFinite(valor)) {
    return '0';
  }

  // Garantir que decimais seja um número válido
  const decimaisValidos = isNaN(decimais) || decimais < 0 ? 3 : Math.min(decimais, 10);

  return valor.toFixed(decimaisValidos).replace('.', ',');
}

/**
 * Converte string ou número para número válido (aceita vírgula ou ponto)
 * @param valor Valor a ser convertido
 * @param fallback Valor padrão se a conversão falhar (padrão: 1)
 * @returns Número válido
 */
export function parseNumero(valor: string | number | undefined | null, fallback: number = 1): number {
  if (typeof valor === 'number') {
    return isNaN(valor) ? fallback : valor;
  }

  if (!valor) return fallback;

  // Converter para string e substituir vírgula por ponto
  const strValor = String(valor).replace(',', '.').trim();
  const numero = parseFloat(strValor);

  return isNaN(numero) ? fallback : numero;
}


